import { render } from "./GlobalLoader.vue?vue&type=template&id=173baffb"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/globals/GlobalLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "173baffb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('173baffb', __exports__)) {
    console.log('reload')
    api.reload('173baffb', __exports__)
  }
  
  module.hot.accept("./GlobalLoader.vue?vue&type=template&id=173baffb", () => {
    console.log('re-render')
    api.rerender('173baffb', render)
  })

}


export default __exports__